<template>
    <div>
         <b-form-group
            :label="label"
        >
            <flat-pickr
                v-model="valueLocal"
                :value="value"
                :class="[
                    classe,
                    isError && 'form-error'
                ]"
                :disabled="disabled"
                :config="type == 'data' ? {altInput: true, altFormat: 'd/m/Y',dateFormat: 'Y-m-d', mode:mode, position:position,  minDate: minDate, defaultDate:defaultDate, disableMobile: true} : { altInput: true, enableTime: true,noCalendar: true,dateFormat: 'H:i', time_24hr: true, altFormat: 'H:i',disableMobile: true}"
                @input="updateSelectValue(valueLocal)"
            />
            <calendarIcon v-if="type =='data'"/>
            <timeIcon v-else/>

        </b-form-group>
        <p class="msgError" v-if="isError">{{msgError}}</p>
    </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import calendarIcon from '@/assets/images/pages/calendar-icon.svg'
import timeIcon from '@/assets/images/pages/time-icon.svg'

export default {
   components: {
        BFormGroup,
        flatPickr,
        calendarIcon,
        timeIcon
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        classe: {
            type: String,
            default: '',
        },
        minDate: {
            type: Date,
            default: '',
        },
        defaultDate: {
            type: Array,
            default: [],
        },
        mode: {
            type: String,
            default: 'single',
        },
        position: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        value: {
            default: '',
        },
        isError: {
            type: Boolean,
            default: false,
        },
        msgError: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return{
            valueLocal: ''
        }
    },
    watch:{
        value(){
            if (this.value){
                this.valueLocal = this.value
            }
        }
    },
    mounted() {
        if (this.value){
            this.valueLocal = this.value
        }
    },
    methods: {
        updateSelectValue: function (value) {
            this.$emit("input", value);
        },
    
  },
}
</script>
<style>
.form-error ~ .form-control{
    border: 1px solid #D32F2F !important;
}

</style>
